// import styled from 'styled-components';
// import { darken } from 'polished';

// export const Container = styled.div`
//   > h2 {
//     padding: 20px 10px 10px;
//   }
// `;

// export const Wrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   background: #ffffff;
//   border: 1px solid #dbe1e9;
//   border-radius: 5px;
//   padding: 20px 30px;
// `;

// export const InputButtonContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;

//   > button {
//     border: 0;
//     border-radius: 5px;
//     height: 42px;
//     width: 50px;
//     background: none;
//     color: #cbd0d8;
//     transition: all 1s;
//     &:hover {
//       background: ${darken(0.1, '#f2f5fc')};
//       color: ${darken(0.1, '#1789dd')};
//     }
//   }
// `;

// export const Footer = styled.div``;

// Footer.Action = styled.div`
//   display: flex;
//   align-items: center;
//   padding: 10px 5px;

//   > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     border-radius: 5px;
//     border: 0;
//     height: 42px;
//     min-width: 150px;

//     > svg {
//       margin-right: 5px;
//     }

//     & + button {
//       margin-left: 10px;
//     }

//     &#btn-new {
//       background: #ff6d3c;
//       color: #fff;
//       transition: background 1s;

//       &:hover {
//         background: ${darken(0.05, '#ff6d3c')};
//       }
//     }

//     &#btn-upload {
//       background: none;
//       color: #1789dd;
//       font-weight: normal;
//       transition: color 1s;

//       &:hover {
//         color: ${darken(0.1, '#1789dd')};
//       }
//     }
//   }
// `;

import styled from 'styled-components';
import { darken } from 'polished';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c (gradiente)   --blue: #1789dd
   --ink: #17263b / #2c405a   --muted: #cbd0d8
   --border: rgba(216, 224, 235, 0.9)
=========================================================== */

const PRIMARY_GRADIENT =
  'linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%)';

export const Container = styled.div`
  > h2 {
    padding: 20px 10px 10px;
    color: #17263b;
    font-size: 22px;
    letter-spacing: -0.4px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 30px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(23, 38, 59, 0.06),
    0 1px 0 rgba(255, 255, 255, 0.9) inset;
`;

export const InputButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 50px;
    border: 0;
    border-radius: 10px;
    background: none;
    color: #cbd0d8;
    cursor: pointer;
    transition: color 0.2s ease, background 0.2s ease, transform 0.2s ease;

    &:hover {
      background: rgba(23, 137, 221, 0.1);
      color: ${darken(0.1, '#1789dd')};
      transform: translateY(-1px);
    }
  }
`;

export const Footer = styled.div``;

Footer.Action = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 5px;

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    min-width: 150px;
    border: 0;
    border-radius: 12px;
    font-weight: 800;
    cursor: pointer;

    > svg {
      margin-right: 5px;
    }

    & + button {
      margin-left: 10px;
    }

    &#btn-new {
      color: #fff;
      background: ${PRIMARY_GRADIENT};
      box-shadow: 0 12px 26px rgba(255, 109, 60, 0.3);
      transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 16px 32px rgba(255, 109, 60, 0.42);
        filter: brightness(1.02);
      }
    }

    &#btn-upload {
      background: none;
      color: #1789dd;
      font-weight: 600;
      transition: color 0.2s ease;

      &:hover {
        color: ${darken(0.1, '#1789dd')};
      }
    }
  }
`;
